import React from 'react';
import PropTypes from 'prop-types';
import VerticalLabelList from '../../../../label/VerticalLabelList';
import FieldSet from '../../../../fieldset/FieldSet';
import '../UtilityView.css';

class KsDLCoADetail extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    const { submission, } = this.props;

    const submissionItems = VerticalLabelList.toList({
      'Drivers License Number': submission.submission.DLNum,
      'Organ Donor': submission.submission.OrganDonor,
      'Registered to Vote': submission.submission.RegisterVote,
      'Political Party': submission.submission.RegisterVote,
      'Email Opt In': submission.submission.EmailOptIn,
    });

    const residentialAddressItems = VerticalLabelList.toList({
      'Address Line 1': submission.submission.NewAddress1,
      'Address Line 2': submission.submission.NewAddress2,
      City: submission.submission.NewCity,
      State: submission.submission.NewState,
      ZIP: submission.submission.NewZip,
      County: submission.submission.NewCounty,
      'Is Mailing & Residential Address the Same': submission.submission.IsMailResidentialSame,
    });

    const mailingAddressItems = VerticalLabelList.toList({
      'Address Line 1': submission.submission.MailAddress1,
      'Address Line 2': submission.submission.MailAddress2,
      City: submission.submission.MailCity,
      State: submission.submission.MailState,
      ZIP: submission.submission.MailZip,
      County: submission.submission.MailCounty,
    });

    const ownerItems = VerticalLabelList.toList({
      'First Name': submission.firstName,
      'Middle Name': submission.middleName,
      'Last Name': submission.lastName,
      'Phone Number': submission.submission.Phone,
      'Email Address': submission.submission.Email,
    });

    const transactionItems = VerticalLabelList.toList({
      'Transaction Id': submission.submission.TransactionId,
    });

    return (
      <div>
        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="License Information">
            <VerticalLabelList
              items={submissionItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Residential Address Information Information">
            <VerticalLabelList
              items={residentialAddressItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '50px', }}>
          <FieldSet title="Mailing Address Information Information">
            <VerticalLabelList
              items={mailingAddressItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Owner Information">
            <VerticalLabelList
              items={ownerItems}
            />
          </FieldSet>
        </div>

        <div className="column-2" style={{ marginTop: '20px', }}>
          <FieldSet title="Transaction Information">
            <VerticalLabelList
              items={transactionItems}
            />
          </FieldSet>
        </div>
      </div>
    );
  }
}

KsDLCoADetail.propTypes = {
  submission: PropTypes.instanceOf(Object).isRequired,
};

export default KsDLCoADetail;
